<template>
<Modal :label="`${inputType} Data Kelas`">
    <InputCustom
      v-model="item.name" 
      :error="error.name"
      :errorMsg="errorMsg.name"
      @onFocus="resetError('name')"
      placeholder="Kelas"
      label="Kelas"
    >
    </InputCustom>

    <SelectCustom
      :roValue="semesterValue"
      v-model="search.semester"
      label="Semester"
      refName="semester_name"
      :show="showSelect == 'semester_name'"
      :list="filterSemesters"
      @click="toggleShow('semester_name')"
      @close="closeSelect()"
      @select="selectedSemester($event)"
      @mouseleave="showSelect = null"
    >
      <template #autocompleteitem="props">
        {{props.data.name}} {{props.data.type}}
      </template>
    </SelectCustom>

    <div class="y-inputField">
        <div class="y-labelText">
          Tipe
        </div>
        <div class="y-inputPlace y-hasIcon-right">
            <div class="y-select-hasIcon" style="width: 100%">
                <select class="y-select" v-model="item.type">
                    <option class="y-option"
                      value="tapi1"
                      >TAPI 1</option>
                    <option class="y-option"
                      value="tapi2"
                      >TAPI 2</option>
                </select>
                <div class="y-select-icon" >
                    <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                </div>
            </div>
        </div>
    </div>
    
    <div class="y-inputField">
        <div class="y-labelText">
          Status
        </div>
        <div class="y-inputPlace y-hasIcon-right">
            <div class="y-select-hasIcon" style="width: 100%">
                <select class="y-select" v-model="item.is_active">
                    <option class="y-option"
                      :value="true"
                      >Aktif</option>
                    <option class="y-option"
                      :value="false"
                      >Tidak Aktif</option>
                </select>
                <div class="y-select-icon" >
                    <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                </div>
            </div>
        </div>
    </div>

    <template #actionButton>
      <ButtonCustom
        :disabled="loading" type="secondary" size="sm" class="r-mlr-10"
        @click.prevent="resetData()"
      > Batal </ButtonCustom>
      
      <ButtonCustom
        :loading="loading"
        type="primary" size="sm" class="r-mlr-10"
        @click.prevent="sendData()"
      >{{inputType}} </ButtonCustom>
    </template>
</Modal>
</template>
<script>
import common from '@/mixins/function/common'
import { mapGetters, mapActions } from 'vuex'
import validation from '@/mixins/function/validation'
import Modal from '@/components/Helper/Modal'
import inputNumber from '@/mixins/function/inputNumber'
import selectMixins from '@/mixins/selectMixins'

export default {
  mixins: [common, validation, inputNumber, selectMixins],
  components: {
    Modal,
  },
  props: {
    inputType: {
      require: true
    }
  },
  computed: {
    ...mapGetters({
      item: 'tapiClass/getItem',
      semesters: 'semester/getSemesters',
    }),
    filterSemesters(){
      if(!this.search.semester) return this.semesters
      return this.semesters.filter(row => {
        const tempRow = `${row.name} ${row.type}`
        return tempRow.toLowerCase().includes(this.search.semester.toLowerCase())
      })
    },
    semesterValue(){
      if(this.item.semester_name == null) return null
      return `${this.item.semester_name} ${this.item.semester_type}`
    }
  },
  data: () => ({
    loading: false,
    search: {
      semester: null
    },
    error: {
      name: false,
      type: false,
      semester_id: false,
      semester_name: false,
    },
    errorMsg: {
      name: 'Tidak boleh kosong',
      type: 'Tidak boleh kosong',
      semester_id: 'Tidak boleh kosong',
      semester_name: 'Tidak boleh kosong',
    },
  }),
  methods: {
    ...mapActions({
      submit: 'tapiClass/submit',
    }),
    resetData(){
      this.$emit('resetData')
    },
    async validation(){
      const field = [
        'name',
        'type',
        'semester_id'
      ]
      return await this.validate(field,this.item)
    },
    selectedSemester(selected){
      this.item.semester_name = selected.name
      this.item.semester_type = selected.type
      this.item.semester_id = selected.id
      this.closeSelect()
    },
    async sendData(){
      const errorcount = await this.validation()
      if(errorcount === 0){

        this.loading = true
        await this.submit(this.item)
        this.loading = false

        const response = this.getResponse('tapiClass')
        this.showSnackbar({
          type: response.status == 1 ? "success" : "error",
          text: response.msg
        })

        if(response.status === 1){
          this.resetData()
          this.$emit('getData')
        }

      }else{
        this.showSnackbar({
          type: "error",
          text: "Mohon periksa kembali"
        })
      }
    },
  }
}
</script>